import documentHelper from "helpers/documentHelper";

export class FileTypeToIconValueConverter {
    protected toView(value: string): string {
        return documentHelper.getIconClass(value);
    }
}
